var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-8",attrs:{"flat":""}},[_c('div',{staticClass:"personality-test-results"},[_c('ResultsChart',{attrs:{"data":_vm.results,"max":Number(120)}}),_c('ResultsDetailed',{attrs:{"results":_vm.results}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }